import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLoginUrl } from '../../utils/Constant';
import SplashContent from './SplashContent';


const SplashScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
  const timer = setTimeout(() => {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
    if (token) {
      navigate('/home');
    } else {
      window.location.href = getLoginUrl();
    }
  }, 2000);
  return () => clearTimeout(timer);
}, [navigate]);

  return (
    <div className="bg-white absolute left-0 top-0  w-screen h-screen flex flex-col  justify-center items-center">
      <SplashContent />
    </div>
  );
};

export default SplashScreen;
